import type {
  CountryBidderCount,
  ProjectBidStats,
} from './project-bid-stats.model';

export interface GenerateProjectBidStatsOptions {
  readonly projectId: number;
  readonly bidCount: number;
  readonly bidAvg?: number;
  readonly minAmount?: number;
  readonly maxAmount?: number;
  readonly minPeriod?: number;
  readonly maxPeriod?: number;
  readonly bidderCountPerCountry?: readonly CountryBidderCount[];
  readonly maxReviewCount?: number;
  readonly minReviewCount?: number;
}

export function generateProjectBidStatsObject(
  options: GenerateProjectBidStatsOptions,
): ProjectBidStats {
  return {
    id: options.projectId,
    ...options,
  };
}
